import Tooltip from 'antd/lib/tooltip';
import Icon from 'antd/lib/icon';
import React from 'react';

class HeyNedHint extends React.PureComponent {
  render() {
    return (
      <Tooltip title={this.props.tooltipText}>
        <Icon
          type={this.props.type}
          style={{
            color: '#999',
            fontSize: this.props.iconSize,
            hover: 'cursor',
          }}
        />
      </Tooltip>
    );
  }
}

HeyNedHint.defaultProps = {
  tooltipText: '',
  type: 'question-circle-o',
  iconSize: 15,
};

export default HeyNedHint;



// WEBPACK FOOTER //
// ./src/components/common/HeyNedHint/index.js